export const CHANNELS = {
  SESSION_DETAILS: "cme-common", 
  QNA: "user-qna", 
  POLL: "user-poll", 
  CHAT: "chat-recive", 
  CHAT_SENT: "chat-sent", 
  QUIZ_RESULT: "quiz-result", 
  CREATIVE: "stratcreative",
  // HCP viewers and their meeting status: { clientID, name, joinMeeting }.
  USERS: "users",
};

export const ADMIN_CHANNELS = {
  ADMIN_QNA: "admin-qna",
  ADMIN_POLL: "admin-poll",
};

// Ably message names: commands ride the same channels as data but are addressed by
// name, so consumers can tell a command apart from a session payload.
export const MESSAGE_NAMES = {
  CONTROL: "control",
};

// cme-common carries frequent partial updates (health ticks, streamToUser, cmestatus),
// so the last full cmeall snapshot can sit hundreds of messages back - with only the
// newest 100 the session cache never got its base. Read up to 500 (5 pages x 100), the
// same depth clir-rj-cme-core uses.
export const SESSION_DETAILS_HISTORY = { limit: 100, maxPages: 5 };

export function buildChannelName(sessionId, channel = CHANNELS.SESSION_DETAILS) {
  return `streaming:${channel}-${sessionId}`;
}


